import * as Sentry from '@sentry/react';

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN || '',
    enabled: !!import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,

    // Low-rate tracing in production, full in development
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

    // No Session Replay in this pass
    integrations: [],

    // Avoid capturing PII — no estate details in breadcrumbs
    beforeBreadcrumb(breadcrumb) {
        // Strip request bodies from fetch breadcrumbs
        if (breadcrumb.category === 'fetch' && breadcrumb.data) {
            delete breadcrumb.data.request_body;
        }
        return breadcrumb;
    },
});

export default Sentry;
